import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AppConfigService, TokenService } from '@cudirect/shared-ui-library';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { StorageService } from '@workflow/service/storage/storage.service';
import { AuthType, NoAppsLoginType } from '@shared/enum';

@Component({
  selector: 'cu-dx-logout',
  template: ``
})
export class DXLogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private configService: AppConfigService,
    private userService: UserService,
    private storageService: StorageService
  ) {}
  /** Variable to hold auth type: phone or email */
  private authType: string;

  ngOnInit(): void {
    const userLoginType = this.userService.userLoginType;
    this.authType = userLoginType === NoAppsLoginType.EmailAddress ? AuthType.Phone : AuthType.Email;
    if (this.userService.user) {
      this.userService.logout();
      this.storageService.clear();
    }
    this.tokenService.clearCachedToken();
    this.router.navigate(['/user/login'], {
      queryParams: {
        authType: this.authType
      }
    });
  }
}
